// extracted by mini-css-extract-plugin
export default {"page":"ConsentsPage_page__i5wSi","title":"ConsentsPage_title__RqGrW"};